<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col v-if="prevRoute && prevRoute.name === 'EXCMCaseShow'">
          <router-link :to="{ path: prevRoute.path }" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.backToCase')}}</router-link>
        </b-col>
        <b-col v-else>
          <router-link :to="{ name: 'EXCMAgreementList' }" class="mb-1 btn btn-sm btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row v-if="item">

        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <p>
                    <b>{{$t('views.exsbsettlements.show.valueNetto')}}:</b> {{ item['valueNetto'] }}<br>
                    <b>{{$t('views.exsbsettlements.show.valueBrutto')}}:</b> {{ item['valueBrutto'] }}<br>
                  </p>
                  <template v-if="item.positions.length > 0">
                    <table class="text-center border-table">
                      <tr>
                        <th>X</th>
                        <th>{{$t('views.exsbdocument.show.documentPosition.lp')}}</th>
                        <th>{{$t('views.exsbdocument.show.documentPosition.item')}}</th>
                        <th>{{$t('views.exsbdocument.show.documentPosition.quantity')}}</th>
                        <!--<th>{{$t('views.exsbdocument.show.documentPosition.measure')}}</th>-->
                        <!--<th>{{$t('views.exsbdocument.show.documentPosition.discount')}}</th>-->
                        <th>{{$t('views.exsbdocument.show.documentPosition.pricePerUnitNetto')}}</th>
                        <th>{{$t('views.exsbdocument.show.documentPosition.vatRate')}}</th>
                        <th>{{$t('views.exsbdocument.show.documentPosition.pricePerUnitBrutto')}}</th>
                      </tr>
                      <tr v-for="(position, index) in item.positions" v-bind:key="index">
                        <td>
                          <b-form-checkbox v-model="selectedPositions" selected :value="position['@id']"></b-form-checkbox>
                        </td>
                        <td>{{ index + 1 }}</td>
                        <td>{{ position.item.name }}</td>
                        <td>{{ position.quantity }}</td>
                        <!--<td>{{ position.item.measure.name }}</td>-->
                        <!--<td>{{ position.discount }}</td>-->
                        <td>{{ position.pricePerUnitNetto }}</td>
                        <td>{{ position.vatRate.range }}</td>
                        <td>{{ position.pricePerUnitBrutto }}</td>
                      </tr>
                    </table>
                    <b-row>
                      <b-col>
                        <b-btn variant="success" v-b-modal.modal-1>{{ $t('buttons.generateInvoice') }}</b-btn>
                      </b-col>
                    </b-row>
                  </template>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-modal id="modal-1" size="xl" hide-footer @hidden="resetData">
        <b-row slot="modal-header">
          <b-col>
            <h6>{{ $t('views.exsbsettlements.show.modalHeader') }}</h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <Loader v-if="isLoading"></Loader>
            <template v-else>
              <b-row>
                <b-col>
                  <div class="form-group">
                    <label class="form-control-label">{{$t('views.exsbsettlements.show.invoiceType')}}:</label>
                    <model-select  v-model="invoiceType" :options="invoiceTypeOptions" name="type" id="type" :placeholder="$t('global.type')">
                    </model-select>
                  </div>
                </b-col>
                <b-col>
                  <div class="form-group">
                    <label class="form-control-label">{{$t('views.exsbsettlements.show.batchNumber')}}:</label>
                    <fg-input>
                      <el-select
                              class="select-default"
                              filterable
                              :disabled="invoiceType === null"
                              remote
                              reserve-keyword
                              v-model="batchNumber">
                        <el-option v-for="option in batchNumberOptions"
                                   class="select-default"
                                   :value="option['@id']"
                                   :label="option.name"
                                   :key="option['@id']">
                        </el-option>
                      </el-select>
                    </fg-input>
                  </div>
                </b-col>
                <b-col>
                  <div class="form-group">
                    <label class="form-control-label">{{$t('views.exsbsettlements.show.paymentWay')}}:</label>
                    <fg-input>
                      <el-select
                              class="select-default"
                              filterable
                              remote
                              reserve-keyword
                              v-model="paymentWay">
                        <el-option v-for="option in paymentWayOptions"
                                   class="select-default"
                                   :value="option['@id']"
                                   :label="option.name"
                                   :key="option['@id']">
                        </el-option>
                      </el-select>
                    </fg-input>
                  </div>
                </b-col>
                <b-col>
                  <div class="form-group">
                    <label class="form-control-label">{{$t('views.exsbsettlements.show.invoiceStatus')}}:</label>
                    <fg-input>
                      <el-select
                              class="select-default"
                              filterable
                              remote
                              reserve-keyword
                              v-model="invoiceStatus">
                        <el-option v-for="option in invoiceStatusOptions"
                                   class="select-default"
                                   :value="option['@id']"
                                   :label="option.name"
                                   :key="option['@id']">
                        </el-option>
                      </el-select>
                    </fg-input>
                  </div>
                </b-col>
                <b-col>
                  <div class="form-group">
                    <label class="form-control-label">{{$t('views.exsbsettlements.show.paymentDeadline')}}:</label>
                    <fg-input>
                      <el-date-picker
                              :picker-options="{firstDayOfWeek: 1}"
                              v-model="paymentDeadline"
                              type="date"
                              :placeholder="$t('views.exsbsettlements.form.paymentDeadline')"
                              default-time="12:00:00">
                      </el-date-picker>
                    </fg-input>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <p>{{$t('views.exsbsettlements.show.selectedPositionsQuantity')}}: <b>{{ selectedPositions.length }}</b></p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-btn variant="success" @click="generateInvoice()">{{ $t('buttons.generate') }}</b-btn>
                  <b-btn @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
                </b-col>
              </b-row>
            </template>
          </b-col>
        </b-row>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../../Layout/Loader'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import { ModelSelect } from 'vue-search-select'

export default {
  computed: mapGetters({
    deleteError: 'exsbsettlement/del/error',
    error: 'exsbsettlement/show/error',
    isLoading: 'exsbsettlement/show/isLoading',
    item: 'exsbsettlement/show/retrieved',
    documentTypeOptions: 'exsbinvoice/list/documentTypeOptions',
    invoiceTypeOptions: 'exsbinvoice/list/invoiceTypeOptions',
    invoiceStatusOptions: 'exsbinvoice/list/invoiceStatusOptions',
    paymentWayOptions: 'exsbinvoice/list/paymentWayOptions'
  }),

  components: {
    Loader,
    ModelSelect
  },

  data () {
    return {
      batchNumbersForInvoiceType: [],
      prevRoute: null,
      selectedPositions: [],
      generateInvoiceClicked: 0,
      invoiceType: null,
      paymentWay: null,
      batchNumber: null,
      batchNumberOptions: [],
      invoiceStatus: null,
      paymentDeadline: this.$moment().format('YYYY-MM-DD')
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
    this.getInvoiceTypes()
    this.getBatchNumbers()
    this.getPaymentWays()
    this.getInvoiceStatuses()
    this.createInvoiceTypeWatcher()
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  methods: {
    ...mapActions({
      del: 'exsbsettlement/del/del',
      reset: 'exsbsettlement/show/reset',
      retrieve: 'exsbsettlement/show/retrieve',
      getInvoiceStatuses: 'exsbinvoice/list/fetchInvoiceStatusOptions',
      getPaymentWays: 'exsbinvoice/list/fetchPaymentWayOptions',
      getInvoiceTypes: 'exsbinvoice/list/fetchInvoiceTypeOptions'
    }),

    closeModal () {
      this.$bvModal.hide('modal-1')
    },

    prepareBatchNumbersForInvoiceType (invoiceType) {
      this.batchNumbersForInvoiceType = []
      for (let i in this.batchNumberOptions) {
        for (let j in this.batchNumberOptions[i].documentsAllowed) {
          if (this.batchNumberOptions[i].documentsAllowed[j] === invoiceType) {
            this.batchNumbersForInvoiceType.push(this.batchNumberOptions[i])
          }
        }
      }
    },

    createInvoiceTypeWatcher () {
      this.unwatchInvoiceType = this.$watch(
        function () {
          return this.invoiceType
        },
        function (val) {
          this.batchNumber = null
          this.prepareBatchNumbersForInvoiceType(val)
        }
      )
    },

    resetData () {
      this.invoiceType = null
      this.paymentWay = null
      this.batchNumber = null
      this.invoiceStatus = null
      this.paymentDeadline = this.$moment().format('YYYY-MM-DD')
      this.positions = []
    },

    async generateInvoice () {
      this.$Swal({
        title: this.$t('views.exsbsettlements.show.generateInvoiceQuestion') + '?',
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then(async (result) => {
        if (result) {
          this.generateInvoiceClicked = 1
          let sendData = {
            idInvoiceType: this.invoiceType,
            idPaymentWay: this.paymentWay,
            idBatchNumber: this.batchNumber,
            idInvoiceStatus: this.invoiceStatus,
            paymentDeadline: this.$moment(this.paymentDeadline).format('YYYY-MM-DD'),
            positions: this.selectedPositions
          }
          sendData.invoiceDocumentType = this.documentTypeOptions[0].value
          if (sendData.idInvoiceType) {
            sendData.idInvoiceType = parseInt(this.getIdLink(sendData.idInvoiceType))
          }
          if (sendData.idPaymentWay) {
            sendData.idPaymentWay = parseInt(this.getIdLink(sendData.idPaymentWay))
          }
          if (sendData.idBatchNumber) {
            sendData.idBatchNumber = parseInt(this.getIdLink(sendData.idBatchNumber))
          }
          if (sendData.idInvoiceStatus) {
            sendData.idInvoiceStatus = parseInt(this.getIdLink(sendData.idInvoiceStatus))
          }
          for (let i in sendData.positions) {
            sendData.positions[i] = parseInt(this.getIdLink(sendData.positions[i]))
          }
          const response = await new ApiService('e_x_s_b_invoices/generate_from_positions').post(sendData)
          if (response.status < 300) {
            let newInvoice = await response.json()
            this.$router.push({ name: 'EXSBInvoiceShow', params: { id: newInvoice['@id'] } })
          }
          this.generateInvoiceClicked = 0
        }
      })
    },

    async getBatchNumbers () {
      let params = { pagination: false }
      const response = await new ApiService('e_x_s_b_batch_numbers', params).getResults()
      this.batchNumberOptions = response.items
    },

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXSBSettlementList' }))
      }
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
